/**
 * Compact coin display: 999 → "999", 1500 → "1.5K", 2_500_000 → "2.5M", 1_200_000_000 → "1.2B"
 */
export const formatCoin = (val) => {
  const n = Number(val);
  if (!Number.isFinite(n)) return "0";
  const abs = Math.abs(n);
  const sign = n < 0 ? "-" : "";

  const trim = (v) => {
    const s = v.toFixed(1);
    return s.endsWith(".0") ? s.slice(0, -2) : s;
  };

  if (abs >= 1_000_000_000) return `${sign}${trim(abs / 1_000_000_000)}B`;
  if (abs >= 1_000_000) return `${sign}${trim(abs / 1_000_000)}M`;
  if (abs >= 1_000) return `${sign}${trim(abs / 1_000)}K`;
  return `${sign}${Math.round(abs)}`;
};

export default formatCoin;
